import { createType } from 'framework/utils/createType';

export const SettlementProposalsTabTypes = createType('sps', 'unhandled');
export type SettlementProposalsTabType = typeof SettlementProposalsTabTypes[number];
